import React from 'react';

import moment from 'moment';
import styled from 'styled-components';

import { LTTable } from '@lambdatestincprivate/lt-components';

import { TestTypes } from '../../../../constants/View';
import { isMobileDevice } from '../../../../utils/testHelpers';
import { isCDPTest } from '../../../../utils/utilityFunctions';

const BasicInfoWrapper = styled.div`
  overflow: auto;
  height: 100%;
  @media only screen and (max-width: 320px) {
    min-height: 100px;
  }
`;
const BasicInfo = ({
  browserSubVersion,
  hypertestTaskId = '',
  testDetails,
}) => {
  const {
    category = '',
    createdAt = '',
    endedAt = '',
    id = '',
    osDetails = {},
    appiumVersion = 'Not Available',
    seleniumVersion = 'Not Available',
    session_id = '',
    startedAt = '',
    status = '',
    tunnelIdentifier = 'Not Available',
    type = TestTypes.SELENIUM,
    username = '',
    vm_geo_info = {},
  } = testDetails;

  let startedAtDate = 'Not available';
  let endedAtDate = 'Not available';
  let createdAtDate = 'N / A';
  if (startedAt) {
    startedAtDate = moment(new Date(startedAt)).format(
      'HH:mm:ss | DD MMM YYYY'
    );
  }
  if (endedAt) {
    endedAtDate = moment(new Date(endedAt)).format('HH:mm:ss | DD MMM YYYY');
  }
  if (createdAt) {
    createdAtDate = moment(createdAt).format('HH:mm:ss | DD MMM YYYY');
  }

  const isCDP = isCDPTest(type);
  let vmGeoInfo = {};
  if (vm_geo_info) {
    try {
      vmGeoInfo = JSON.parse(vm_geo_info);
      // Remove 'Provider' [MLE-13465]
      if (vmGeoInfo['provider']) {
        delete vmGeoInfo['provider'];
      }

      // renaming state as city
      if (vmGeoInfo['state']) {
        vmGeoInfo['city'] = vmGeoInfo['state'];
        delete vmGeoInfo['state'];
      }
    } catch {
      // Do nothing
    }
  }
  const osName = osDetails?.name || 'N / A';
  const osVersion = osDetails?.version || 'N / A';
  const metaData = {
    ...(status?.toLowerCase() !== 'cancelled' && {
      'Session ID': session_id,
      'Created Time': createdAtDate,
    }),
    'Test ID': id,
    Status: status,
    ...(category === 'windows' && {
      'Server Edition OS Name': osName,
      'Server Edition OS Version': osVersion,
    }),
    ...(hypertestTaskId && {
      'Hypertest Task ID': hypertestTaskId,
    }),
  };

  const data = {
    Username: username,
    'Automation Backed': isCDP
      ? 'Chrome Devtools Protocol'
      : type === TestTypes.CYPRESS
      ? 'Cypress'
      : 'WebDriver',
    'Start Time': startedAtDate,
    'End Time': endedAtDate,
    ...(type === TestTypes.SELENIUM &&
      !isMobileDevice(testDetails) && {
        'Selenium Version': seleniumVersion || 'Not Available',
      }),
    ...(type === TestTypes.SELENIUM &&
      isMobileDevice(testDetails) && {
        'Appium Version': appiumVersion || 'Not Available',
      }),
    'Tunnel ID': tunnelIdentifier || 'Not Available',
    ...(browserSubVersion && {
      'Browser Version': browserSubVersion,
    }),
    ...vmGeoInfo,
    ...metaData,
  };

  return (
    <BasicInfoWrapper data-testid="basic-info-tab-container">
      <div style={{ height: '1px' }}>
        <LTTable allowValueCopy={true} data={data} data-testid="basic-info-table" tabIndex={0} />
      </div>
    </BasicInfoWrapper>
  );
};

export default BasicInfo;
